import React, { Component, PropTypes } from 'react'
import { Link, browserHistory } from 'react-router'
import Dialog from '../dialog'
import { formHandler, TextInput, Button } from '../ui'

function redirectToSignIn() {
    browserHistory.push('/sign-in')
}

export default class ResetPassword extends Component {
    static displayName = 'ResetPassword'

    static propTypes = {
        account: PropTypes.shape({
            validation: PropTypes.string,
            set_password: PropTypes.string,
            reset_password_errors: PropTypes.object,
        }).isRequired,
        actions: PropTypes.shape({
            validateResetPasswordToken: PropTypes.func.isRequired,
            setPassword: PropTypes.func.isRequired,
        }).isRequired,
        appState: PropTypes.shape({
            loading: PropTypes.bool.isRequired,
        }).isRequired,
        params: PropTypes.shape({
            token: PropTypes.string.isRequired,
            uuid: PropTypes.string.isRequired,
        }).isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            data: {},
        }

        this.updateValue = formHandler.updateValue.bind(this)
    }

    componentWillMount() {
        this.props.actions.validateResetPasswordToken(
            this.props.params.uuid,
            this.props.params.token
        )
    }

    setPassword = () => {
        this.props.actions.setPassword(
            this.props.params.uuid,
            this.props.params.token,
            this.state.data
        )
    }

    render() {
        const validation = this.props.account.validation
        const set_password = this.props.account.set_password
        const errors = this.props.account.reset_password_errors || {}

        const header = (
            <div className="logo">
                <img alt="" src="/img/hayden-logo.png" width="200" />
            </div>
        )

        let content = null
        let non_field_errors = null

        if (errors.non_field_errors) {
            non_field_errors = (
                <div className="alert alert--error">
                    { errors.non_field_errors.map(
                        (error, index) => <div key={ index }>{ error }</div>
                    ) }
                </div>
            )
        }

        if (this.props.appState.loading && ! validation) {
            content = (
                <div className="align-center">
                    <span className="loader loader--large loader--red" />
                </div>
            )
        } else if (set_password === 'PASSWORD_SET') {
            content = (
                <div className="align-center">
                    <p>
                        Your password has been reset. You can now sign in with your new password
                    </p>
                    { non_field_errors }
                    <Button
                        fullWidth
                        onClick={ redirectToSignIn }
                        status="primary"
                    >
                        Sign in
                    </Button>
                </div>
            )
        } else if (validation === 'USER_INVALID') {
            content = (
                <div className="align-center">
                    <p>The reset link is invalid.</p>
                    <p><Link to="/forgot-password">Get a new reset link</Link></p>
                </div>
            )
        } else if (validation === 'TOKEN_INVALID' || set_password === 'TOKEN_INVALID') {
            content = (
                <div className="align-center">
                    <p>The reset link is invalid.</p>
                    <p><Link to="/forgot-password">Get a new reset link</Link></p>
                </div>
            )
        } else if (validation === 'TOKEN_VALID') {
            content = (
                <div className="align-center">
                    <p>Please enter your new password twice.</p>
                    { non_field_errors }
                    <TextInput
                        error={ errors.password1 }
                        name="password1"
                        placeholder="Choose a password"
                        type="password"
                        updateValue={ this.updateValue }
                        value={ this.state.data.password1 }
                    />
                    <TextInput
                        error={ errors.password2 }
                        name="password2"
                        placeholder="Enter new password again"
                        type="password"
                        updateValue={ this.updateValue }
                        value={ this.state.data.password2 }
                    />
                    <Button
                        fullWidth
                        onClick={ this.setPassword }
                        status="primary"
                    >
                        Save password
                    </Button>
                </div>
            )
        }

        return (
            <Dialog allowClose={ false } background={ false } header={ header } open size="small">
                <h4 className="align-center">Reset password</h4>
                { content }
            </Dialog>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/account/reset_password.js